export function useCommonRules(t) {
  const required = (v) => {
    return !!v || t("validations.required");
  };

  const percents = (v) => {
    if (!v) return true;
    v = Number(v.replaceAll(",", "."));
    return (v >= 0 && v <= 100) || t("validations.percents");
  };

  const positive = (v) => {
    if (!v) return true;
    return Number(v.replaceAll(",", ".")) >= 0 || t("validations.positive");
  };

  const atLeastOne = (v) => {
    if (!v) return true;
    return Number(v.replaceAll(",", ".")) >= 1 || t("validations.atLeastOne");
  };

  return {
    required,
    percents,
    positive,
    atLeastOne
  };
}
